<template>
  <div id="app">
    <router-view /> <!-- This renders the component based on the active route -->
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>